export default __webpack_public_path__ + "static/media/icon_logo.c70effb8.svg";